import { useEffect } from 'react';
// theme
import ThemeProvider from './theme';

import { workWithLocalStorage, buildBody, isEmpty } from './auxiliares/funciones';
import CONFIG from './CONFIG.json';

import Index from './plantilla/principal';
import Login from './paginas/Login';

// ----------------------------------------------------------------------

export default function App() {
  
    const usuario = workWithLocalStorage('get','usuario',null);

    useEffect(() => {
      const usuario2 = workWithLocalStorage('get','usuario',null);
      
      if(usuario2 !== undefined){
        const bodyJson = JSON.stringify(buildBody(CONFIG.TOKEN,{
          usuario: usuario2.usuario
        }))
            fetch(`${CONFIG.api}usuario/check`,{
                      method: 'POST',
                      body: bodyJson,
                      headers: {'Content-Type': 'application/json'}
              })
              .then(res => res.json())
              .then((result) => {
                if (result.error === 0 && !isEmpty(result.data)) {
                  const unloadCallback = (event) => {
                    event.preventDefault();
                    event.returnValue = "";
                    return "";
                  };
                  window.addEventListener("beforeunload", unloadCallback);
                  return () => window.removeEventListener("beforeunload", unloadCallback);
                }    
                workWithLocalStorage('remove','usuario');    
                window.location.reload();
            })



        
      }

      return () =>{}

      }, []);

  
    return (
      <ThemeProvider>
        { usuario === undefined ?
        <Login />
        :
        <Index />
        }
      </ThemeProvider>
    );
}
